import axios from "axios";
import { AppSettingsResponse } from "generated/CoreApi_v1";
import { SessionStore } from "services/SessionStore";
import { AuthService, TokenRenew } from "services/authService";
import { getTenantConfig, TenantApis } from "services/tenantService";

export class SessionService {

    public apiPaths: TenantApis;
    private tokenRenewInstance = new TokenRenew();
    private STORAGE_VERSION = 'PowerMindsVersion';
    private CAROUSEL_HOME = "Carousel-HOME";
    private CAROUSEL_LMS = "Carousel-LMS";

    constructor() {
        this.apiPaths = getTenantConfig();
    }

    /**
     * Limpa o cache local da configuração de Carrossel.
     */
    public clearCarouselData() {
        sessionStorage.removeItem(this.CAROUSEL_HOME);
        sessionStorage.removeItem(this.CAROUSEL_LMS);
    }

    /**
     * Obtem o cache do carrossel da HOME.
     */
    public getCarouselHomeConfig() {
        sessionStorage.getItem(this.CAROUSEL_HOME);
    }

    /**
     * Salva o cache do carrossel da HOME.
     */
    public setCarouselHomeConfig(config: string) {
        sessionStorage.setItem(this.CAROUSEL_HOME, config);
    }

    /**
     * Obtem o cache do carrossel do LMS.
     */
    public getCarouselLmsConfig() {
        sessionStorage.getItem(this.CAROUSEL_LMS);
    }

    /**
     * Salva o cache do carrossel dO LMS.
     */
    public setCarouselLmsConfig(config: string) {
        sessionStorage.setItem(this.CAROUSEL_LMS, config);
    }

    /**
     * Constroi a URL para obter um asset.
     * @param id Identificação do Asset.
     * @returns
     */
    public getAssetUrl(id: string | null | undefined) {
        return id ? `${SessionService.current.apiPaths.coreApi}/GetAsset/${id}` : undefined;
    }

    /**
     * Constroi a URL absoluta para acesso à API.
     * @param relativePath
     * @returns
     */
    public getApiFullUrl(relativePath: string | null | undefined) {
        return (relativePath == null || relativePath.startsWith("http"))
            ? relativePath
            : `${SessionService.current.apiPaths.coreApi}${relativePath.startsWith("/") ? '' : '/'}${relativePath}`;
    }

    /**
     * Obtém as URL de imagens padrão do sistema.
     */
    public get defaultImages() {
        return {
            backgroundUrl: `${SessionService.current.apiPaths.coreApi}/DefaultBackground`,
            logoUrl: `${SessionService.current.apiPaths.coreApi}/DefaultLogo`,
            highlightImageUrl: `${SessionService.current.apiPaths.coreApi}/DefaultHighlightImage`
        };
    }

    /**
     * Obtém as URL de imagens do sistema.
     */
    public get appImages() {
        return {
            backgroundUrl: `${SessionService.current.apiPaths.coreApi}/Background`,
            logoUrl: `${SessionService.current.apiPaths.coreApi}/Logo`,
            highlightImageUrl: `${SessionService.current.apiPaths.coreApi}/HighlightImage`
        };
    }

    /**
     * Retorna a Versão do Aplicativo
     */
    public get appVersion() {
        return localStorage.getItem(this.STORAGE_VERSION);
    }

    /**
     * Verifica se há uma nova versão do aplicativo
     */
    public checkNewSystemVersion(releaseNumber: string) {

        const last_version = localStorage.getItem(this.STORAGE_VERSION);
        if (last_version == null) {
            localStorage.setItem(this.STORAGE_VERSION, releaseNumber);
            return false;
        }
        if (last_version !== releaseNumber) {
            localStorage.setItem(this.STORAGE_VERSION, releaseNumber);
            return true;
        }

        return false;
    }

    /**
     * Obtém as configurações do APP.
     */
    static getSettings(): Promise<AppSettingsResponse> {

        return axios.get<AppSettingsResponse>(
            SessionService.current.apiPaths.coreApi + "/GetAppSettings",
            {
                headers: { "content-type": "application/json" }
            })
            .then((res) => {
                return res.data;
            })
            .catch((error: any) => {
                throw error;
            });
    }

    /**
     * Executa Download de uma URL utilizando token de acesso.
     * @param url
     * @param title
     */
    static downloadWithToken(url: string, title?: string): void {

        function doDownload(token: string) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = SessionService.current.apiPaths.coreApi + url + (url.indexOf("?") > -1 ? "&" : "?") + "access_token=" + token;
            a.download = "true";
            if (title) a.target = title;
            a.click();
            document.body.removeChild(a);
        }

        this.getAccessToken()
            .then((token) => {
                if (token != null) doDownload(token);
                else alert("Não foi possível realizar o download.");
            })
            .catch(() => {
                alert("Não foi possível realizar o download.");
            });
    }

    /**
     *
     * @returns Obtem um token de acesso.
     */
    static async getAccessToken() {
        if (SessionStore.bearerString() != "") {

            // Obtém um novo token se o atual expirar em 10s.
            if (SessionStore.tokenExpired(10)) {
                try {
                    const token = await AuthService.updateToken(SessionService.current.tokenRenewInstance);
                    if (token != null) return token.access_token;
                }
                catch { }
            }

            // Token atual
            return SessionStore.accessToken();
        }
        return "";
    }

    /////////////////////////////////////////////////////////////////////
    // Singleton
    /////////////////////////////////////////////////////////////////////
    private static _sessionService: SessionService | null = null;

    /**
     * SessionService Singleton.
     */
    static get current(): SessionService {
        return this._sessionService || (this._sessionService = new SessionService());
    }
}
